import React from 'react'
import FetchData from '../../../shared/fetchData'
import { updateObject } from '../../../shared/utility'
import Button from '../../UI/Button/Button'
import ContentForm from '../../UI/ContentForm/ContentForm'
import Input from '../../UI/Input/Input'
import { Grid } from '@material-ui/core'
import './SystemPolicyForm.css'

const SystemPolicyForm = (props) => {

    const [loading, setLoading] = React.useState(false)
    const [changeForm, setChangeForm] = React.useState(false)
    const [policy, setPolicy] = React.useState({
        maxKioskNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "بیشترین تعداد لاکر در هر جستجو"
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        maxDistanceToKiosk: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "بیشترین فاصله لاکر",
                unit: 'متر'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        maxIntervalReserveFromNow: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "بیشترین فاصله زمانی تا رزرو",
                unit: 'دقیقه'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        minDurationReserve: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "کمترین زمان مجاز برای رزرو",
                unit: 'دقیقه'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        maxDurationReserve: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "بیشترین زمان مجاز برای رزرو",
                unit: 'دقیقه'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        deadlineOfConfirmOrder: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "بیشترین زمان مجاز برای تایید سفارش",
                unit: 'دقیقه'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        },
        cancelInterval: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: "حداقل فاصله زمانی برای کنسل کردن",
                unit: 'دقیقه'
            },
            validation: {
                required: true
            },
            errorMessage: 'الزامی است',
            valid: true,
            value: ''
        }
    })
    React.useEffect(() => {
        const sp = policy
        sp['maxKioskNumber'].value = props.systemPolicy.maxKioskNumber
        sp['maxDistanceToKiosk'].value = props.systemPolicy.maxDistanceToKiosk
        sp['maxIntervalReserveFromNow'].value = props.systemPolicy.maxIntervalReserveFromNow
        sp['minDurationReserve'].value = props.systemPolicy.minDurationReserve
        sp['maxDurationReserve'].value = props.systemPolicy.maxDurationReserve
        sp['deadlineOfConfirmOrder'].value = props.systemPolicy.deadlineOfConfirmOrder
        sp['cancelInterval'].value = props.systemPolicy.cancelInterval
        setPolicy(sp)
        if (changeForm) {
            setChangeForm(false)
        } else {
            setChangeForm(true)
        }
    }, [])
    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(policy, {
            [controlName]: updateObject(policy[controlName], {
                value: event.target.value
            })
        });
        setPolicy(updatedControls)
    }
    const editSystemPolicy = (event, id) => {
        let valid = true
        const plcy = policy
        for (let key in plcy) {
            if (plcy[key].value == null || plcy[key].value == '') {
                plcy[key].valid = false
                valid = false
            }
        }
        if (!valid) {
            setPolicy(plcy)
            if (changeForm) {
                setChangeForm(false)
            } else {
                setChangeForm(true)
            }
        } else {
            var raw = JSON.stringify({
                "maxKioskNumber": policy.maxKioskNumber.value,
                "maxDistanceToKiosk": policy.maxDistanceToKiosk.value,
                "maxIntervalReserveFromNow": policy.maxIntervalReserveFromNow.value,
                "minDurationReserve": policy.minDurationReserve.value,
                "maxDurationReserve": policy.maxDurationReserve.value,
                "deadlineOfConfirmOrder": policy.deadlineOfConfirmOrder.value,
                "cancelInterval": policy.cancelInterval.value,
                "version": "mtpx001"
            })

            var url = 'management/api/v1/systempolicies/insertSystemPolicy'
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    setLoading(false)
                    if (result.status == 0) {
                        props.toggleNewPolicyForm(event, false)
                    }
                })
                .catch(error => setLoading(false))
        }
    }
    const formElementsArray = [];
    for (let key in policy) {
        formElementsArray.push({
            id: key,
            config: policy[key]
        })
    }

    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="6 mt-2"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    return (
        <div className='row justify-content-center'>
            <Grid lg={6} md={10} sm={11} xs={11}>
                <ContentForm headetText='کنترل های سیستمی'>
                    <div className='lckr-tp-frm'>
                        {form}
                    </div>
                    <div className='col-12'>
                        <div className='row justify-content-center w-100 mt-3'>
                            <div className='col-6 text-center'>
                                <Button btnType="General" clicked={(event) => props.toggleNewPolicyForm(event, false)}>برگشت</Button>
                            </div>
                            <div className='col-6 text-center'>
                                <Button btnType="Success" clicked={editSystemPolicy}>ثبت</Button>
                            </div>
                        </div>
                    </div>
                </ContentForm>
            </Grid>
        </div>
    )
}

export default SystemPolicyForm